import { useProviderProps } from "@react-spectrum/provider";
import _react from "react";
import { filterDOMProps } from "@react-aria/utils";
import { classNames, useDOMRef, useSlotProps, useStyleProps } from "@react-spectrum/utils";
import _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";

// incomplete component for show right now
function $a10f4145261977a79a7655ffe33849cc$var$Image(props, ref) {
  props = useSlotProps(props, 'image');

  let _useProviderProps = useProviderProps(props),
      {
    objectFit,
    src,
    alt
  } = _useProviderProps,
      otherProps = _babelRuntimeHelpersEsmObjectWithoutPropertiesLoose(_useProviderProps, ["objectFit", "src", "alt"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let domRef = useDOMRef(ref);

  if (alt == null) {
    console.warn('The `alt` prop was not provided to an image. ' + 'Add `alt` text for screen readers, or set `alt=""` prop to indicate that the image ' + 'is decorative or redundant with displayed text and should not be annouced by screen readers.');
  }

  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersEsmExtends({}, filterDOMProps(props), styleProps, {
    className: classNames({}, styleProps.className),
    style: _babelRuntimeHelpersEsmExtends({}, styleProps.style, {
      overflow: 'hidden'
    }),
    ref: domRef
  }), /*#__PURE__*/_react.createElement("img", {
    src: src,
    alt: alt,
    style: {
      objectFit,
      height: '100%',
      width: '100%'
    }
  }));
}
/**
 * Image is used to insert and display an image within a component.
 */


export const Image = _react.forwardRef($a10f4145261977a79a7655ffe33849cc$var$Image);
//# sourceMappingURL=module.js.map
